import { IChecklistItem } from "@oneethos/shared"
import { ChecklistItemConfigAction } from "../reducers/checklistItemReducer"

export const actions = {
  loadChecklistItemsConfig(): ChecklistItemConfigAction {
    return { type: 'LOAD_CHECKLIST_ITEMS' }
  },

  setChecklistItemsConfig(items: IChecklistItem[]): ChecklistItemConfigAction {
    return { type:'SET_CHECKLIST_ITEMS', data: items }
  },

  setChecklistItemsConfigError(err: string): ChecklistItemConfigAction {
    return { type: 'SET_CHECKLIST_ITEMS_ERROR', data: err }
  },

  saveChecklistItemRequest(): ChecklistItemConfigAction {
    return { type: 'SAVE_CHECKLIST_ITEM_REQUEST' }
  },

  saveChecklistItemSuccess(item: IChecklistItem): ChecklistItemConfigAction {
    return { type: 'SAVE_CHECKLIST_ITEM_SUCCESS', data: item }
  },

  saveChecklistItemError(err: string): ChecklistItemConfigAction {
    return { type: 'SAVE_CHECKLIST_ITEM_ERROR', data: err }
  },
}

export default actions